module.exports = "<div class=\"postagem\">\r\n  <video width=\"100%\" controls controlsList=\"nodownload\" *ngIf=\"type === 'file'\" style=\"background: #000000\">\r\n    <source [src]=\"videoLink\" />\r\n  </video>\r\n  <iframe width=\"560\" height=\"315\" [src]=\"videoLink\" frameborder=\"0\"  *ngIf=\"type !== 'file'\" allowfullscreen></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/feed/embed/embed.component.html
// module id = ./src/app/shared/feed/embed/embed.component.html
// module chunks = main